import { db, storage } from "./firebase";
import { collection, addDoc, onSnapshot, deleteDoc, doc, query, where, serverTimestamp, getDocs, writeBatch, orderBy, updateDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';


export const onFurnitureChange = (ownerId, callback) => {
    const furnitureRef = collection(db, 'furniture');
    
    const q = query(furnitureRef, where("ownerId", "==", ownerId));

    const unsubscribe = onSnapshot(q, (snapshot) => {
        const furniture = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        const sortedFurniture = furniture.sort((a, b) => {
            const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : 0;
            const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : 0;
            return dateB - dateA;
        });

        callback(sortedFurniture);
    }, (error) => {
        console.error("Error listening to furniture changes:", error);
        callback([]);
    });

    return unsubscribe;
};

export const addFurniture = (furnitureData) => {
    const furnitureRef = collection(db, 'furniture');
    return addDoc(furnitureRef, {
        ...furnitureData,
        createdAt: serverTimestamp()
    });
};

export const updateFurniture = (furnitureId, data) => {
    const furnitureDocRef = doc(db, 'furniture', furnitureId);
    return updateDoc(furnitureDocRef, data);
};

export const deleteFurniture = async (furnitureId, imageUrl) => {
    if (imageUrl && imageUrl.includes('firebasestorage.googleapis.com')) {
        try {
            const imageRef = ref(storage, imageUrl);
            await deleteObject(imageRef);
        } catch (error) {
            if (error.code === 'storage/object-not-found') {
                console.warn("Image not found in storage, but deleting reference from Firestore.");
            } else {
                console.error("Error deleting image from storage. Continuing to delete Firestore document.", error);
            }
        }
    }
    const furnitureDocRef = doc(db, 'furniture', furnitureId);
    return deleteDoc(furnitureDocRef);
};


export const uploadFurnitureImage = (file, progressCallback, customPath) => {
    return new Promise((resolve, reject) => {
        const filePath = customPath || `furniture/images/${uuidv4()}-${file.name}`;
        const storageRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (progressCallback) progressCallback(progress);
            },
            (error) => {
                console.error("Upload failed:", error);
                reject(error);
            },
            async () => {
                try {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                } catch (error) {
                    console.error("Failed to get download URL:", error);
                    reject(error);
                }
            }
        );
    });
};
